module.exports = __webpack_public_path__ + "img/Stadtkörper.b7800e20.jpg";